import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { InstitucionComponent } from "./institucion/institucion.component";
import { InstitucionRoutingModule } from "./institucion.routing.module";

@NgModule({
    declarations: [
        InstitucionComponent
    ],
    imports: [
        CommonModule , 
        FormsModule , 
        ReactiveFormsModule , 
        SharedModule, 
        InstitucionRoutingModule , 
        NgbAccordionModule
    ]
})
export class InstitucionModule {}